var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MoreVert } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import ActionMenuList from "../../../../builderPackage/components/actionsMenuList";
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import InfiniteScroll from "../../../../builderPackage/components/infiniteScroll/infiniteScroll";
import { showSurface } from "../../../../redux/awaitedSurfacesSlice";
import { useAppDispatch } from "../../../../store/hooks";
export var IRsMobileView = function (props) {
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var data = [{
            id: 1
        }, {
            id: 2
        }, {
            id: 3
        }, {
            id: 4
        }, {
            id: 5
        }];
    var elements = [{
            type: FormItemTypes.CardComponent,
            name: 'Selected',
            columnSize: 12,
            contentProps: {
                spacing: 0
            },
            setFieldProps: function (formValues, currValue, field) {
                return {
                    type: this.type,
                    sx: {
                        borderColor: currValue ? 'info.main' : 'secondary.200',
                        p: 0
                    }
                };
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    padding: '12px 12px 0 12px',
                    elements: [{
                            type: FormItemTypes.CheckBox,
                            name: 'Selected',
                            value: false,
                            label: null,
                            columnSize: 0,
                            containerProps: {
                                spacing: 0,
                                mt: '-7px',
                                mr: '-12px'
                            }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: true,
                            spacing: 0,
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: 'title-containter',
                                    spacing: 0,
                                    columnSize: true,
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'Name',
                                            fontWeight: 'strong',
                                            columnSize: 0,
                                            value: 'FFR-9883992',
                                            textTransform: 'capitalize'
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            color: 'text.secondary',
                                            value: '17 Oct, 2020 ',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }]
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    columnSize: true,
                                    spacing: 0,
                                    gap: '12px',
                                    justifyContent: 'end',
                                    flexWrap: 'nowrap',
                                    elements: [{
                                            type: FormItemTypes.Chip,
                                            name: 'StatusName',
                                            label: 'Submitted to ASM',
                                            columnSize: 0,
                                            color: 'info',
                                            size: 'small',
                                            shape: 'rounded'
                                        }, {
                                            type: FormItemTypes.IconButton,
                                            name: '',
                                            children: /*#__PURE__*/ React.createElement(MoreVert, null),
                                            // variant: 'outlined',
                                            size: 'small',
                                            columnSize: 0,
                                            color: 'info',
                                            sx: {
                                                paddingTop: 0
                                            },
                                            setFormState: function (state, e) { return __awaiter(void 0, void 0, void 0, function () {
                                                var res;
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                                type: 'Menu',
                                                                containerProps: {
                                                                    anchorEl: e.target.parentElement
                                                                },
                                                                Component: ActionMenuList,
                                                                componentProps: {
                                                                    items: [{
                                                                            id: 'Resend to PSG',
                                                                            children: 'Resend to PSG'
                                                                        }, {
                                                                            id: 'Close IR',
                                                                            children: 'Close IR'
                                                                        }, {
                                                                            id: 'Edit',
                                                                            children: 'Edit'
                                                                        }, {
                                                                            id: 'View',
                                                                            children: 'View'
                                                                        }, {
                                                                            id: 'Print',
                                                                            children: 'Print'
                                                                        }, {
                                                                            id: 'Download PDF',
                                                                            children: 'Download PDF'
                                                                        }, {
                                                                            id: 'Share',
                                                                            children: 'Share'
                                                                        }]
                                                                }
                                                            }))];
                                                        case 1:
                                                            res = _a.sent();
                                                            if ((res === null || res === void 0 ? void 0 : res.payload) == 'Edit') {
                                                                navigate('/iRs/editIR');
                                                            }
                                                            return [2 /*return*/];
                                                    }
                                                });
                                            }); }
                                        }]
                                }]
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    p: 2,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            spacing: 0,
                            rowGap: '4px',
                            borderRadius: '8px',
                            p: 1,
                            sx: {
                                bgcolor: 'background.secondary'
                            },
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'Part:',
                                    label: 'Group name & code: ',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'Part name & code:',
                                    label: 'Part name & code:',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'Defect description & code:',
                                    label: 'Defect description & code: ',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'Owner:',
                                    label: 'Owner: ',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'Category:',
                                    label: ' Category:',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'Priority:',
                                    label: ' Priority:',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'Assigned to:',
                                    label: ' Assigned to:',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'Assigned by:',
                                    label: ' Assigned by:',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'Intensity:',
                                    label: ' Intensity:',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'Ageing:',
                                    label: ' Ageing:',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'Source:',
                                    label: ' Source:',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'PSG remarks:',
                                    label: ' PSG remarks:',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }],
                            columnSize: 12,
                            setFieldProps: function (formValues, currValue) {
                                return {
                                    type: this.type,
                                    containerProps: {
                                        my: currValue ? 1.5 : 0
                                    }
                                };
                            }
                        }]
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(InfiniteScroll, {
        apiKey: "asd",
        apiCall: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, {
                        data: data
                    }];
            });
        }); },
        elements: elements,
        hasMore: true,
        gridContainerProps: {
            spacing: 2,
            p: 0
        }
    }));
};
